// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/sconti-fornitore?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":"ScontoFornitore[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&limit=200&societaId=N',
    requestBody: null,
    response: '{"data":"Nominativo[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/sconti?societaId=N&mostraDisattivati=false',
    requestBody: null,
    response: '"ScontoItem[]"'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/sconti-fornitore/:fornitoreId?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":"ScontoFornitore|null"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli?societaId=N&q=&tipologia=&page=1&limit=30',
    requestBody: null,
    response: '{"success":true,"data":"ArticoloRicerca[]","total":"number"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/sconti-fornitore/:fornitoreId',
    requestBody: '{"societaId":"number","vendBassoId":"number|null","vendMedioId":"number|null","vendAltoId":"number|null","vendMaxId":"number|null","acqBassoId":"number|null","acqMedioId":"number|null","acqAltoId":"number|null","acqMaxId":"number|null"}',
    response: '{"success":true,"data":"ScontoFornitore"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
